import { useTheme } from '@mui/material/styles';

export const CustomXTickText = (props) => {
  const { payload, x, y } = props; // props from recharts
  const theme = useTheme();

  // dy spacing between wrapped tick label lines
  const getDistance = () => 16;

  // split words with space to array of words
  const chunks = payload.value.split(' ');

  // display each word with tspan
  // note: dy have to scale with fontSize

  const tspans = chunks.map((s, i) => (
    <tspan dy={i === 0 ? 0 : getDistance()} key={i} x={0}>
      {s}
    </tspan>
  ));

  return (
    <g transform={`translate(${x}, ${y + 5})`}>
      <text
        fill={theme.fuel6Tokens.JddcColorTextSecondary}
        style={{ fontSize: 15 }}
        textAnchor="middle"
        dy={26}
      >
        {tspans}
      </text>
    </g>
  );
};
